import type { IMosaicTocExpanded, ITocActionShowSaveAlert } from "./interface";

/**
 * Shows the major-version alert for an incoming ToC save message.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the ToC identifier from the message.
 * @returns The updated ToC state with the save alert visible.
 */
export const toc_showTocSaveAlert = (
  state: IMosaicTocExpanded,
  action: ITocActionShowSaveAlert,
): IMosaicTocExpanded => ({
  ...state,
  showSaveAlert: true,
  tocIdFromMessage: action.tocIdFromMessage,
});
